import React, { useState, useEffect } from 'react';
import './TokenExpiredNotification.css';

const TokenExpiredNotification = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleTokenExpired = () => {
      setShow(true);
      // Tự động ẩn thông báo sau 3 giây
      setTimeout(() => {
        setShow(false);
      }, 3000);
    };

    window.addEventListener('auth-logout', handleTokenExpired);

    return () => {
      window.removeEventListener('auth-logout', handleTokenExpired);
    };
  }, []);

  if (!show) return null;

  return (
    <div className="token-expired-notification">
      <div className="notification-content">
        <span className="notification-icon">⚠️</span>
        <span className="notification-message">
          Phiên đăng nhập đã hết hạn. Đang chuyển về trang đăng nhập...
        </span>
      </div>
    </div>
  );
};

export default TokenExpiredNotification;
